// GENERATED by tools/build_score_ts.py — do not edit here.
// Adding a piece to this course means adding one transcription JSON and
// re-running the generator. No new component, no new route.
import type { Score } from "@/courses/sight-reading/types";
import { firstSteps } from "./first-steps.score";
import { twinkleMelody } from "./twinkle-melody.score";
import { gMajorRun } from "./g-major-run.score";
import { jesuJoyMelody } from "./jesu-joy-melody.score";
import { bareNecessities } from "./bare-necessities.score";
import { feedingDucks } from "./feeding-ducks.score";
import { overTheRainbowC } from "./over-the-rainbow-c.score";
import { overTheRainbowAb } from "./over-the-rainbow-ab.score";
import { meetTheFlintstones } from "./meet-the-flintstones.score";
import { twinkleLeftHand } from "./twinkle-left-hand.score";
import { twinkleArpeggios } from "./twinkle-arpeggios.score";
import { jesuJoyHarmony } from "./jesu-joy-harmony.score";
import { puffTheMagicDragon } from "./puff-the-magic-dragon.score";
import { odeToJoy } from "./ode-to-joy.score";
import { funAtThePark } from "./fun-at-the-park.score";
import { irishDancing } from "./irish-dancing.score";
import { marchingForward } from "./marching-forward.score";
import { threeBlindMice } from "./three-blind-mice.score";
import { rockNRoll } from "./rock-n-roll.score";
import { rainyDay } from "./rainy-day.score";
import { twoByTwo } from "./two-by-two.score";
import { aMajorClimb } from "./a-major-climb.score";
import { stopAndGo } from "./stop-and-go.score";
import { bassFirstLook } from "./bass-first-look.score";
import { walkingDown } from "./walking-down.score";
import { leftHandLullaby } from "./left-hand-lullaby.score";
import { aMinorWaltz } from "./a-minor-waltz.score";
import { mirror } from "./mirror.score";
import { boatSong } from "./boat-song.score";
import { stormComing } from "./storm-coming.score";

export const SCORES: Score[] = [
  firstSteps,
  twinkleMelody,
  gMajorRun,
  jesuJoyMelody,
  bareNecessities,
  feedingDucks,
  overTheRainbowC,
  overTheRainbowAb,
  meetTheFlintstones,
  twinkleLeftHand,
  twinkleArpeggios,
  jesuJoyHarmony,
  puffTheMagicDragon,
  odeToJoy,
  funAtThePark,
  irishDancing,
  marchingForward,
  threeBlindMice,
  rockNRoll,
  rainyDay,
  twoByTwo,
  aMajorClimb,
  stopAndGo,
  bassFirstLook,
  walkingDown,
  leftHandLullaby,
  aMinorWaltz,
  mirror,
  boatSong,
  stormComing,
];

export const SCORE_BY_SLUG: Record<string, Score> =
  Object.fromEntries(SCORES.map((s) => [s.slug, s]));
